import {NgModule} from '@angular/core';
import {IndicationRestService} from './indication/indication-rest.service';
import {EnvironmentService} from '../../environment/environment.service';
import {ConsentChapterRestService} from '@core/modules/rest/consent-chapter/consent-chapter-rest.service';
import {ConsentUseCaseRestService} from '@core/modules/rest/consent-use-case/consent-use-case-rest.service';
import {ConsentRestService} from '@core/modules/rest/consent/consent-rest.service';
import {QuestionsRestService} from '@core/modules/rest/questions/questions-rest.service';
import {TtsRestService} from '@core/modules/rest/text-to-speech/tts-rest.service';
import {WizardRestService} from '@core/modules/rest/wizard/wizard-rest.service';
import {UserRestService} from '@core/modules/rest/user/user-rest.service';
import {InformationUnitRestService} from '@core/modules/rest/informationunit/information-unit-rest.service';
import {OrganizationRestService} from '@core/modules/rest/organization/organization-rest.service';

@NgModule({
    imports: [],
    providers: [
        IndicationRestService,
        ConsentChapterRestService,
        ConsentUseCaseRestService,
        ConsentRestService,
        QuestionsRestService,
        EnvironmentService,
        TtsRestService,
        WizardRestService,
        UserRestService,
        InformationUnitRestService,
        OrganizationRestService
    ]
})
export class RestModule {

}
